import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { NewRequisitionSkills } from 'src/app/core/models/newRequistionSkills';
import { RequisitionSkill } from 'src/app/core/models/requisitionSkill';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { map, switchMap } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { ManageSkillsService } from 'src/app/core/services/manage-skills.service';
import { AngularModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-requisition-skills',
  templateUrl: './requisition-skills.component.html',
  styleUrls: ['./requisition-skills.component.css']
})
export class RequisitionSkillsComponent implements OnInit {

  @Input() currentJobStatus;
  @Input() isUploadRequisition;
  @Input() jobTitle;
  @Input() jobLocation;
  @Input() allExistingSkills;
  @Input() allExistingDegrees;
  @Input() allExistingFieldOfStudy;
  @Input() allExistingRoles;
  @Input() allUpdatedRoles;
  @Input() allExistingCertificates;
  @Input() allExistingJDActionWords;
  @Input() timePeriods;
  @Input() skillsTimePeriods;
  @Input() isSharedReq;
  @Input() profileCriteriaInfo;
  @Input() stepOneHasError;
  @Input() isJobProfile;
  @Input() includeCandidateAdditionalDetails;
  @Input() includeCandidatesMatchingMandatoryCriteria;
  @Output() showJobProfileCallback =  new EventEmitter<any>();
  @Output() updateLocationCallback = new EventEmitter<any>();
  @Output() updateJobTitleCallback = new EventEmitter<any>();
  @Output() updateIncludeCandidateDetailsCallback = new EventEmitter<any>();
  @Output() updateIncludeCandidateMatchingMandatoryCriteriaCallback = new EventEmitter<any>();

  public allSkillsObservable:  Observable<any[]>;
  requisitionSkills: any;
  benefitsNotes: any = '';
  editorConfig: any;
  addAllSkills: any = 'education';
  newRequisitionSkill: any = {};
  allEducationsList: any = [];
  educationDepartmentList: any = [];
  experiencesList: any = [];
  certificationsList: any = [];
  ranges: any = [];
  // timePeriods: any = [];
  // skillsTimePeriods: any = [];
  searchSkills: any = [];
  allUpdatedJDActionWords: any = [];
  existingDuplicateSkillName: any = {};
  newSkill: any = new RequisitionSkill('');
  newSkillSearchText: any = '';

  isLoading: boolean = true;
  isViewOnly: boolean = false;
  includeCandidatesWithNoAdditionalDetails: boolean = false;

  constructor(
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private skillsService: ManageSkillsService,
    private modalService: AngularModalService
  ) { 
  }

  ngOnInit() {
    this.isViewOnly = this.isSharedReq ? true : false;
    this.editorConfig = {
      toolbar: [
        ['bold', 'italic', 'h1', 'h2', 'h3'],
        ['underline', 'strikeThrough'],
        ['fontSize'],
        ['orderedList', 'unorderedList'],
        ['undo', 'redo'],
        ['paragraph'],
        ['blockquote'],
        ['removeFormat']
      ]
    };
    this.requisitionSkills = this.profileCriteriaInfo ? this.profileCriteriaInfo : new NewRequisitionSkills();
    this.setAllRequisitionSkills();
    this.isLoading = false;
    this.setSkillsObservable();
  }

  escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
  }

  setAllRequisitionSkills() {
    
    this.ranges = [
      { name: "", value: "" },
      { name: "Atleast", value: "atleast" },
      { name: "Min", value: "min" },
      { name: "Max", value: "max" }
    ];
    this.newRequisitionSkill = new RequisitionSkill('');
    const skillCategories = [
      'educations',
      'experiences',
      'technicalSkills',
      'softSkills',
      'otherSkills',
      'operationalSkills',
      'certifications'
    ];
    if(!this.profileCriteriaInfo) {
      skillCategories.forEach(category => {
        this.requisitionSkills[category].push(new RequisitionSkill(''));
      });
    } else {
      skillCategories.forEach(category => {
        if(!this.requisitionSkills[category] || this.requisitionSkills[category].length === 0) {
          this.requisitionSkills[category] = [];
          this.requisitionSkills[category].push(new RequisitionSkill(''));
        }
      });
    }
    // Set Skills
    this.allExistingSkills.forEach(skill => {
        skill.competency = skill.skill;
    });
    // Set Degrees
    let equivalentDegreeList = [];
    this.allExistingDegrees.forEach(degree => {
      // let tempEquivalentDegree = JSON.parse(JSON.stringify(degree));
      // tempEquivalentDegree.competency = degree.degreeName + " or equivalent experience";
      // tempEquivalentDegree.name = degree.degreeName + " or equivalent experience";
      // tempEquivalentDegree.degreeName = degree.degreeName + " or equivalent experience";
      // equivalentDegreeList.push(tempEquivalentDegree);
      let tempInDegree = JSON.parse(JSON.stringify(degree));
      tempInDegree.competency = degree.degreeName + " in ";
      tempInDegree.name = degree.degreeName + " in ";
      tempInDegree.degreeName = degree.degreeName;
      equivalentDegreeList.push(tempInDegree);
      degree.competency = degree.degreeName;
      degree.name = degree.degreeName;
    });
    this.allExistingDegrees = [...this.allExistingDegrees, ...equivalentDegreeList];
    // Set Roles
    this.allExistingRoles.forEach(role => {
      role.competency = role.role;
    });
    // Set Certificates
    this.allExistingCertificates.forEach(certificate => {
      certificate.competency = certificate.name;
      certificate.inName = certificate.group + " in "
    });
    // Set Jd Action Words
    this.allExistingJDActionWords.forEach(jdAction => {
      if (jdAction.jobDescriptionLanguageDropdown && jdAction.jobDescriptionLanguageDropdown.length > 0) {
        jdAction.jobDescriptionLanguageDropdown.forEach(actionWord => {
          let actionWordTemp = { name: actionWord, jdAction: jdAction };
          this.allUpdatedJDActionWords.push(actionWordTemp);
        });
      }
    });
  }

  skillsSaveCallback(event) {
    if (event && event.length > 0) {
      this.allExistingSkills = event;
    }
  }

  onBenefitsNoteChanged() {

  }

  revertToJobDescriptionFile() {
    let message = "<p>Are you sure?</p><p>All your changes will be lost and will be put back to the uploaded Job Description.</p>";
    this.alertsAndNotificationsService.showConfirm("Revert to Job description file", message, "warning", true, () => {
      // Api for reverting changes to last saved version
      this.alertsAndNotificationsService.showBannerMessage('Changes reverted to uploaded Job Description successfully', 'success');
    }, () => {
      //do nothing  
    });
  }

  revertToSavedChanges() {
    let message = "<p>Are you sure?</p><p>All your changes will be lost and will be put back to the previously saved information.</p>";
    this.alertsAndNotificationsService.showConfirm("Revert to Saved changes", message, "warning", true, () => {
      // Api for reverting changes to last saved version
      this.alertsAndNotificationsService.showBannerMessage('Changes reverted to saved information successfully', 'success');
    }, () => {
      //do nothing  
    });
  }

  revertToOriginalActivatedVersion() {
    let message = "<p>Are you sure?</p><p>Any changes done since the requisition was originally activated, including versions saved after that and any current changes will be lost. You be returned to the original criteria at the time the Requisition was <b>Activated.</b></p><p>This change cannot be <b>undone.</b></p>";
    this.alertsAndNotificationsService.showConfirm("Revert to Original Activated Version", message, "warning", true, () => {
      // Api for reverting changes to last saved version
      this.alertsAndNotificationsService.showBannerMessage('Changes reverted to the original criteria at the time the Requisition was <b>Activated.</b> successfully', 'success');
    }, () => {
      //do nothing  
    });
  }

  onAllSkillsChanges() {
    this.newRequisitionSkill = new RequisitionSkill('');
  }

  showJobProfile() {
    if(this.showJobProfileCallback) {
      this.showJobProfileCallback.emit();
    }
  }

  updateLocation() {
    if(this.updateLocationCallback) {
      this.updateLocationCallback.emit();
    }
  }

  addSkillsToOther(event, type) {
    if (event) {
      this.requisitionSkills.otherSkills.unshift(event);
      let title = "Skill Moved";
      let message = `<b>'${event.skill.skill}'</b> has been moved under <b>'Other'</b>`;
      this.alertsAndNotificationsService.showAlert(title, message, 'warning');
    }
  }

  addSkillsAsPerCategory(event, type) {
    let title = "Skill Moved";
    let categoryHeading = event.skill.category.charAt(0).toUpperCase() + event.skill.category.substring(1).toLowerCase();
    let message = `<b>'${event.skill.skill}'</b> is an <b>'${categoryHeading}'</b> Skill. It has been moved under <b>'${(event.skill.category.toLowerCase() == 'other') ? 'Other' : (categoryHeading + ' Skills')}'</b>`;
    if (event) {
      switch (event.skill.category.toLowerCase()) {
        case 'technical':
          this.requisitionSkills.technicalSkills.unshift(event);
          break;
        case 'operational':
          this.requisitionSkills.operationalSkills.unshift(event);
          break;
        case 'soft':
          this.requisitionSkills.softSkills.unshift(event);
          break;
        case 'other':
          this.requisitionSkills.otherSkills.unshift(event);
          break;
        default:
          this.requisitionSkills.otherSkills.unshift(event);
          break;
      }
      this.alertsAndNotificationsService.showAlert(title, message, 'warning');
    }
  }

  onJobTitleChange() {
    if (this.updateJobTitleCallback) {
      this.updateJobTitleCallback.emit(this.jobTitle);
    }
  }

  onRequisitionSkillSelect(e: TypeaheadMatch, skill, inputElement: HTMLInputElement): void {
    this.newSkill = e.item;
    this.newSkill.favorite = skill.favorite ? skill.favorite : false;
    this.newSkill.mandatory = skill.mandatory ? skill.mandatory : false;
    this.newSkill.niceToHave = skill.niceToHave ? skill.niceToHave : false;
    this.newSkill.preferred = skill.preferred ? skill.preferred : false;
    this.newSkill.priority = skill.priority ? skill.priority : false;
  }

  onSearchSkillChange(searchSkillText: string): void {
    this.newSkillSearchText = searchSkillText;
  }

  updateMandatory(skill) {
    skill.mandatory = !skill.mandatory;
    if (skill.mandatory) {
      skill.niceToHave = false;
      skill.preferred = false;
    }
  }

  updateNiceToHave(skill) {
    skill.niceToHave = !skill.niceToHave;
    if (skill.niceToHave) {
      skill.mandatory = false;
      skill.preferred = false;
    }
  }

  updatePreferred(skill) {
    skill.preferred = !skill.preferred;
    if (skill.preferred) {
      skill.mandatory = false;
      skill.niceToHave = false;
    }
  }

  addNewSkillToList(skills: any[], newSkill: any): any[] {
    const updatedSkills = [...skills];
  
    if (updatedSkills.length > 0) {
      const lastSkill = updatedSkills[updatedSkills.length - 1];
  
      if (!lastSkill.displayName || lastSkill.displayName.trim() === '') {
        updatedSkills.pop(); // remove the last empty skill
      }
    }
  
    updatedSkills.push(newSkill);
    return updatedSkills;
  }

  addNewSkill(inputText: string, type: string, inputEvent: any, skill: any) {
    if (this.newSkill && this.newSkill.displayName && this.newSkill.displayName != '') {
      if (!this.isSkillExists(this.newSkill.displayName, this.newSkill.skillType)) {
        const item = { ...this.newSkill };
        delete item.experience;
  
        const skills = this.requisitionSkills;
        const typeKey = this.newSkill.skillType;
  
        if (typeKey === 'education' || typeKey === 'experience' || typeKey === 'certification') {
          const key = typeKey + 's'; // plural keys like 'educations', 'experiences'
          if (typeKey === 'experience') {
            if (!skills[key] || skills[key].length === 0 ||
                (skills[key].length > 0 && (!skills[key][0].displayName || skills[key][0].displayName.trim() === ''))) {
              skills[key] = skills[key] && skills[key].length ? this.addNewSkillToList(skills[key], this.newSkill) : [this.newSkill];
            } else {
              this.alertsAndNotificationsService.showAlertWithCallBack(`Experience`, `<b>Experience already exists.</b>`, 'warning', () => {
                if (this.isJobProfile) {
                  this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
              });
            }
          } else {
            skills[key] = skills[key] && skills[key].length ? this.addNewSkillToList(skills[key], this.newSkill) : [this.newSkill];
          }
        } else if (this.newSkill.skill && this.newSkill.skill.category) {
          let category = this.newSkill.skill.category.toLowerCase();
          let skillKey = '';
  
          if (category === 'technical') skillKey = 'technicalSkills';
          else if (category === 'operational') skillKey = 'operationalSkills';
          else if (category === 'soft') skillKey = 'softSkills';
          else if (category === 'other') skillKey = 'otherSkills';
  
          if (skillKey) {
            skills[skillKey] = skills[skillKey] && skills[skillKey].length
              ? this.addNewSkillToList(skills[skillKey], item)
              : [item];
          }
        } else if (this.timePeriods.find(timePeriod => timePeriod.name === this.newSkill.displayName)) {
          // Check if time period duplicates exisits in experience category
          const expList = skills['experiences'];

          if (!expList || expList.length === 0 ||
            (expList.length > 0 && (!expList[0].displayName || expList[0].displayName.trim() === ''))
          ) {
            skills['experiences'] = expList && expList.length ? this.addNewSkillToList(expList, this.newSkill) : [this.newSkill];
          } else {
            this.alertsAndNotificationsService.showAlertWithCallBack(`Experience`, `<b>Experience already exists.</b>`, 'warning', () => {
              if (this.isJobProfile) {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
              }
            });
          }

        } else {
          // Default to otherSkills if category is not found
          skills.otherSkills = skills.otherSkills && skills.otherSkills.length
            ? this.addNewSkillToList(skills.otherSkills, item)
            : [item];
        }
  
        this.newSkill = new RequisitionSkill('');
      } else {
        this.displayExistingSkillMessage(this.newSkill.displayName, this.existingDuplicateSkillName, this.newSkill.skillType, () => {
          this.newSkill.displayName = '';
      });
      }
    } else {
      this.alertsAndNotificationsService.showAlertWithCallBack('Empty Entry', 'Please enter details to add', 'warning', () => {
        if (this.isJobProfile) {
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
      });
    }
  }

  setSkillsObservable() {
    this.allSkillsObservable = Observable.create((observer: any) => {
      observer.next(this.newSkillSearchText);
    }).pipe(
      switchMap((token: string) =>
        forkJoin([
          this.skillsService.getSkillsAsObservable(token, 'certification', this.allExistingCertificates),
          this.skillsService.getSkillsAsObservable(token, 'education', {
            degrees: this.allExistingDegrees,
            fieldOfStudy: this.allExistingFieldOfStudy
          }),
          this.skillsService.getSkillsAsObservable(token, 'experience', {
            fieldOfStudy: this.allExistingFieldOfStudy,
            roles: this.allExistingRoles,
            timePeriods: this.timePeriods
          }),
          this.skillsService.getSkillsAsObservable(token, 'skills', {
            skills: this.allExistingSkills,
            skillsTimePeriods: this.skillsTimePeriods
          })
        ])
      ),
      map(([certs, education, experience, skills]) => {
        const all = [...certs, ...education, ...experience, ...skills];
      
        // Filter valid entries
        const filtered = all.filter(item => item && item.displayName);
      
        // Count occurrences of each displayName
        const nameCount = filtered.reduce((acc, item) => {
          const name = item.displayName.trim().toLowerCase();
          acc[name] = (acc[name] || 0) + 1;
          return acc;
        }, {});
      
        // Add 'showLabel' flag if there are duplicates
        const withFlags = filtered.map(item => {
          const name = item.displayName.trim().toLowerCase();
          return {
            ...item,
            showLabel: nameCount[name] > 1
          };
        });
      
        // Sort (optional, based on displayName length)
        return withFlags.sort((a, b) => a.displayName.length - b.displayName.length);
      })
    );
  }  

  clearEntry() {
    this.newSkill = new RequisitionSkill('');
  }

  isSkillExists(displayName: string, skillType): boolean {
    this.existingDuplicateSkillName = {};
    if (!displayName || displayName.trim() === '') return false;

    if (skillType === 'education') {
      return this.checkEducationExists(displayName);
    }

    if (skillType === 'experience' || !skillType) {
      return this.checkExperienceExists(displayName);
    }

    if (skillType === 'certification') {
      return this.checkCertificationExists(displayName);
    }

    return this.checkSkillsExists(displayName, skillType);
  }

  checkEducationExists(displayName: string): boolean {
    const skillName = displayName.trim().toLowerCase();
    const skills = this.requisitionSkills.educations;
    if (!skillName || !skills || !this.allExistingDegrees || !this.allExistingFieldOfStudy) return false;
  
    const skillsToCheck = skills.filter(function(skill) {
      return skill.displayName && skill.displayName.trim() !== '';
    });
  
    const knownDegrees = this.allExistingDegrees.map(function(d) {
      return d.degreeName.toLowerCase();
    });
  
    const knownFields = this.allExistingFieldOfStudy.map(function(f) {
      return f.fieldOfStudy.toLowerCase();
    });
  
    function normalizeTerm(str) {
      return str.replace(/ or equivalent( experience)?( in related field)?$/i, '').trim().toLowerCase();
    }
  
    let inputDegree = '';
    let inputField = '';
    let originalDegree = '';
    let originalField = '';
  
    if (skillName.toLowerCase().indexOf(' in ') !== -1) {
      const inIndex = skillName.toLowerCase().indexOf(' in ');
      const firstPart = skillName.substring(0, inIndex).trim();
      const secondPart = skillName.substring(inIndex + 4).trim();
      originalDegree = firstPart;
      originalField = secondPart;
      inputDegree = normalizeTerm(originalDegree);
      inputField = normalizeTerm(originalField);
    } else {
      const normalized = normalizeTerm(skillName);
      if (knownDegrees.indexOf(normalized) !== -1) {
        inputDegree = normalized;
      } else if (knownFields.indexOf(normalized) !== -1) {
        inputField = normalized;
      } else {
        inputDegree = normalized;
      }
    }
  
    for (let i = 0; i < skillsToCheck.length; i++) {
      const item = skillsToCheck[i];
  
      const itemDisplayName = item.displayName.trim().toLowerCase();
      const existingDegree = item.degreeName ? normalizeTerm(item.degreeName.trim().toLowerCase()) : '';
      const existingField = item.fieldOfStudy ? normalizeTerm(item.fieldOfStudy.trim().toLowerCase()) : '';
  
      // 1. Exact displayName match
      if (itemDisplayName === skillName) {
        this.existingDuplicateSkillName = {
          name: skillName,
          type: 'education',
          label: 'Education'
        };
        return true;
      }
  
      // 3. Entered only a degree - block if any skill has same degree with any FOS
      if (inputDegree && !inputField) {
        if (existingDegree === inputDegree && existingField) {
          this.existingDuplicateSkillName = {
            name: inputDegree,
            type: 'education',
            label: 'Education'
          };
          return true;
        }
      }
  
      // 4. Entered only FOS - block if same FOS exists in a skill with any degree
      if (!inputDegree && inputField) {
        if (existingField === inputField && existingDegree) {
          this.existingDuplicateSkillName = {
            name: inputField,
            type: 'education',
            label: 'Field Of Study'
          };
          return true;
        }
      }
  
      // 5. Input has both degree and FOS - block if same degree exists alone or with any other FOS
      if (inputDegree && inputField) {
        if (existingDegree === inputDegree) {
          this.existingDuplicateSkillName = {
            name: inputDegree,
            type: 'education',
            label: 'Education'
          };
          return true;
        }
  
        if (existingField === inputField && !existingDegree) {
          this.existingDuplicateSkillName = {
            name: inputField,
            type: 'education',
            label: 'Field Of Study'
          };
          return true;
        }
      }
    }
  
    return false;
  }  

  checkCertificationExists(displayName: string): boolean {
    const skills = this.requisitionSkills.certifications;
    if (!displayName || !skills) return false;

    const inputRaw = displayName.trim().toLowerCase();

    const skillsToCheck = skills.length > 0
      ? skills.filter(skill => skill.displayName && skill.displayName.trim() !== '')
      : [];

    // Extract core name from input
    let cleanedInput = inputRaw;
    const inIndex = cleanedInput.lastIndexOf(' in ');
    if (inIndex !== -1) {
      cleanedInput = cleanedInput.substring(inIndex + 4).trim();
    }

    if (!cleanedInput || cleanedInput.length < 2) {
      return false;
    }

    // Loop through existing entered skills
    for (let i = 0; i < skillsToCheck.length; i++) {
      const skill = skillsToCheck[i];
      if (!skill || !skill.displayName) continue;

      const existingRaw = skill.displayName.trim().toLowerCase();
      let cleanedExisting = existingRaw;
      const existingInIndex = existingRaw.lastIndexOf(' in ');
      if (existingInIndex !== -1) {
        cleanedExisting = existingRaw.substring(existingInIndex + 4).trim();
      }

      const isDuplicate =
        cleanedInput === cleanedExisting ||
        inputRaw === existingRaw ||
        cleanedInput === existingRaw ||
        cleanedExisting === inputRaw ||
        cleanedInput.includes(cleanedExisting) ||
        cleanedExisting.includes(cleanedInput);

      if (isDuplicate) {
        this.existingDuplicateSkillName = {
          name: cleanedExisting,
          type: 'certification',
          label: 'Certification'
        };
        return true;
      }
    }

    return false;
  }

  checkSkillsExists(displayName: string, skillType): boolean {
    if (!this.requisitionSkills || !this.skillsTimePeriods) return false;

    const timePeriodObj = this.skillsTimePeriods
      .filter(tp => displayName.toLowerCase().indexOf(tp.name.toLowerCase()) !== -1)
      .sort((a, b) => b.name.length - a.name.length)[0];

    let skillName = displayName;

    // Strip JD action word prefixes (longest match first)
    if (this.allExistingJDActionWords.length) {
      const prefixVariants = this.allExistingJDActionWords.flatMap(word => {
        const base = word.actionword.trim().toLowerCase();
        return [base, ...['in', 'with', 'of', 'at'].map(suffix => `${base} ${suffix}`)];
      }).sort((a, b) => b.length - a.length); // Longest first

      const lowerDisplay = skillName.toLowerCase();
      const matchingPrefix = prefixVariants.find(prefix => lowerDisplay.startsWith(prefix + ' '));

      if (matchingPrefix) {
        const regex = new RegExp('^' + matchingPrefix + '\\s+', 'i');
        skillName = skillName.replace(regex, '');
      }
    }

    // Strip time period if present
    if (timePeriodObj) {
      const safePattern = this.escapeRegExp(timePeriodObj.name);
      skillName = skillName.replace(new RegExp(safePattern, 'i'), '');
    }

    skillName = skillName.trim().toLowerCase();
    if (!skillName) return false;

    const skillCategories = [
      { key: 'technicalSkills', label: 'Technical Skills' },
      { key: 'operationalSkills', label: 'Operational Skills' },
      { key: 'softSkills', label: 'Soft Skills' },
      { key: 'otherSkills', label: 'Other Skills' }
    ];

    for (let i = 0; i < skillCategories.length; i++) {
      const category = skillCategories[i];
      const skillList = this.requisitionSkills[category.key];

      if (skillList && Array.isArray(skillList)) {
        let listToCheck = skillList;

        if (skillType && skillType === 'skills' && skillList.length > 0) {
          listToCheck = skillList.filter(skill => skill.displayName && skill.displayName.trim() !== '');
        }

        const match = listToCheck.some(skill => {
          if (!skill.displayName) return false;

          let existingSkillName = skill.displayName.trim().toLowerCase();

          const existingTimePeriod = this.skillsTimePeriods
            .filter(tp => existingSkillName.indexOf(tp.name.toLowerCase()) !== -1)
            .sort((a, b) => b.name.length - a.name.length)[0];

          if (existingTimePeriod) {
            let safePattern = this.escapeRegExp(existingTimePeriod.name);
            existingSkillName = existingSkillName.replace(new RegExp(safePattern, 'i'), '').trim();
          }

          return existingSkillName === skillName;
        });

        if (match) {
          this.existingDuplicateSkillName = {
            name: skillName,
            type: category.key.replace('Skills', ''),
            label: category.label
          };
          return true;
        }
      }
    }

    return false;
  }

  checkExperienceExists(displayName: string): boolean {
    const skills = this.requisitionSkills.experiences;

    if (
      !displayName ||
      !skills ||
      !this.allExistingRoles ||
      !this.allExistingFieldOfStudy ||
      !this.timePeriods
    ) return false;

    const inputValue = displayName.trim().toLowerCase();
    const skillsToCheck = skills.length > 0
      ? skills.filter(skill => skill.displayName && skill.displayName.trim() !== '')
      : [];


    // Check for exact displayName match
    const exactMatch = skillsToCheck.some(item =>
      item.displayName && item.displayName.trim().toLowerCase() === inputValue
    );

    if (exactMatch) {
      this.existingDuplicateSkillName = {
        name: inputValue,
        type: 'experience',
        label: 'Experience'
      };
      return true;
    }

    // Remove "<timePeriod> experience in", "experience in", etc.
    let cleanedName = inputValue;
    let prefixMatched = false;

    const fullPrefixes: string[] = [];

    // Generate all possible variants for each timePeriod
    this.timePeriods.forEach(tp => {
      const base = tp.name.toLowerCase().trim();
      fullPrefixes.push(`${base} experience in`);
      fullPrefixes.push(`${base} experience`);
      fullPrefixes.push(base);
    });

    // Sort by length DESC to prioritize longest match first
    fullPrefixes.sort((a, b) => b.length - a.length);

    for (let i = 0; i < fullPrefixes.length; i++) {
      const prefix = fullPrefixes[i];
      if (cleanedName.startsWith(prefix)) {
        cleanedName = cleanedName.substring(prefix.length).trim();
        prefixMatched = true;
        break;
      }
    }

    if (!prefixMatched && cleanedName.startsWith('experience in ')) {
      cleanedName = cleanedName.substring('experience in '.length).trim();
      prefixMatched = true;
    }

    // If user entered only prefix and nothing else, return false
    if (prefixMatched && (!cleanedName || cleanedName.length < 2)) {
      return false;
    }

    // Compare cleaned skill against roles/fields/display
    const knownRoles = this.allExistingRoles.map(role => role.role.toLowerCase());
    const knownFields = this.allExistingFieldOfStudy.map(fos => fos.fieldOfStudy.toLowerCase());

    for (let i = 0; i < skillsToCheck.length; i++) {
      const item = skillsToCheck[i];
      const role = item.role ? item.role.trim().toLowerCase() : '';
      const field = item.fieldOfStudy ? item.fieldOfStudy.trim().toLowerCase() : '';
      const display = item.displayName ? item.displayName.toLowerCase() : '';

      if ((role && role === cleanedName && knownRoles.includes(role)) ||
        (field && field === cleanedName && knownFields.includes(field)) ||
        (display && display.includes(cleanedName))) {
        this.existingDuplicateSkillName = {
          name: cleanedName,
          type: 'experience',
          label: 'Experience'
        };
        return true;
      }
    }

    return false;
  }

  extractExactMatch(display: string, value: string): string {
    const regex = new RegExp(`\\b(${value})\\b`, 'i'); // match whole word, case-insensitive
    const match = display.match(regex);
    return match ? match[1] : value;
  }

  displayExistingSkillMessage(inputText, displayName, skillType, successCallback) {
    let name = this.extractExactMatch(inputText, displayName.name);
    if (skillType === 'skills') {
      this.alertsAndNotificationsService.showAlertWithCallBack('Duplicate Skill', `'<b>${(name)}</b>'` + ' Skill already exists' + `${displayName.label ? ' in ' + `'<b>${displayName.label}</b>'` + ' category.' : "."}`, 'warning', () => {
        if (this.isJobProfile) {
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
        if (successCallback) {
          successCallback();
        }
      });
    } else {
      const title = skillType === 'education' ? 'Education' : skillType === 'experience' || (displayName.type === 'experience') ? 'Experience' : 'Certification';
      this.alertsAndNotificationsService.showAlertWithCallBack(`Duplicate ${title}`, `'<b>${(name)}</b>'` + ' already exists.', 'warning', () => {
        if (this.isJobProfile) {
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
        if (successCallback) {
          successCallback();
        }
      });
    }
  }

  isIncludeCandidateAdditionalDetailsChanged() {
    if (this.updateIncludeCandidateDetailsCallback) {
      this.updateIncludeCandidateDetailsCallback.emit(this.includeCandidateAdditionalDetails);
    }
  }

  isIncludeCandidateMatchingMandatoryCriteriaChanged() {
    if (this.updateIncludeCandidateMatchingMandatoryCriteriaCallback) {
      this.updateIncludeCandidateMatchingMandatoryCriteriaCallback.emit(this.includeCandidatesMatchingMandatoryCriteria);
    }
  }

}

